import store from '@/store'

export default function choiseSelectTitleOnLoad (localStorageItem, selectData) {
  const isLocalstorageExist = localStorage.getItem(localStorageItem)
  const selectedOptions = selectData.find(el => el.id == isLocalstorageExist)
  if (localStorageItem === 'bookingSegment') return isLocalstorageExist ? selectedOptions : selectData[0]
  if (localStorageItem === 'bookingLang') return isLocalstorageExist ? selectedOptions : selectData.find(el => el.id == store.state.user.segment.default_lang) 
}
